export function CardCornerCircles() {
  return (
    <>
      <div className="pointer-events-none absolute top-0 right-0 w-24 h-24 overflow-hidden">
        <div className="absolute top-0 right-0 w-24 h-24 translate-x-1/2 -translate-y-1/2 rounded-full bg-white/20 transition-transform duration-500 ease-out group-hover:scale-125" />
      </div>
      <div className="pointer-events-none absolute bottom-0 left-0 w-24 h-24 overflow-hidden">
        <div className="absolute bottom-0 left-0 w-24 h-24 -translate-x-1/2 translate-y-1/2 rounded-full bg-white/20 transition-transform duration-500 ease-out group-hover:scale-125" />
      </div>
    </>
  );
}
